import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Correo extends Component {
  render() {
    return (
        <div>
            <div className="w3-container">
                <h5>Clientes
                <Link to={`/nuevo/0`} className="w3-button w3-tiny w3-blue w3-border-blue w3-border w3-round-large" style={{marginLeft: '17px'}}>Nuevo</Link>
                <button className="w3-button w3-tiny w3-blue w3-border-blue w3-border w3-round-large" style={{marginLeft: '17px'}}>Recibido</button>
                <button className="w3-button w3-tiny w3-blue w3-border-blue w3-border w3-round-large" style={{marginLeft: '17px'}}>Enviado</button>
                </h5>
                <ul className="w3-ul w3-card-4 w3-white">
                    <li className="w3-padding-16 w3-display-container">
                        <img src="https://www.w3schools.com/w3images/avatar2.png" alt='' className="w3-left w3-circle w3-margin-right" style={{width:'35px'}} />
                        <span className="w3-xlarge">Mike</span> <br />
                        <span className='w3-medium'> Hola como estas</span>
                        <Link to={`/correo/25`} className="w3-button w3-border w3-display-right w3-round-large" style={{marginRight: '7px'}}>Ver</Link>
                    </li>
                    <li className="w3-padding-16 w3-display-container">
                        <img src="https://www.w3schools.com/w3images/avatar5.png" alt='' className="w3-left w3-circle w3-margin-right" style={{width:'35px'}} />
                        <span className="w3-xlarge">Jill</span><br />
                        <span className='w3-medium'> Necesito Ayuda</span>
                        <Link to={`/correo/27`} className="w3-button w3-border w3-display-right w3-round-large" style={{marginRight: '7px'}}>Ver</Link>
                    </li>
                    <li className="w3-padding-16 w3-display-container">
                        <img src="https://www.w3schools.com/w3images/avatar6.png" alt='' className="w3-left w3-circle w3-margin-right" style={{width:'35px'}} />
                        <span className="w3-xlarge">Jane</span><br />
                        <span className='w3-medium'> klk</span>
                        <Link to={`/correo/29`} className="w3-button w3-border w3-display-right w3-round-large" style={{marginRight: '7px'}}>Ver</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
  }
}

export default Correo;


// WEBPACK FOOTER //
// ./src/Correo/Correo.js